import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable()
export class Notificaciones {

  readonly CSS_ERROR: string = 'alert-danger';

  readonly ID_SUCCESS = 0;

  /* info para el usuario cidm */
  readonly ID_INFO_CAMBIAR_PASSWORD_USUARIO_CIDM_OK = 10;

  /* errores para el inicio de sesion */
  readonly ID_ERR_NOMBRE_PRODUCTO = -10;
  readonly ID_ERR_RUBRO_PRODUCTO = -11;
  readonly ID_ERR_CATEGORIA_PRODUCTO = -12;
  readonly ID_ERR_MARCA_PRODUCTO = -13;
  readonly ID_ERR_PRECIO_PRODUCTO = -14;

  /* errores para el inicio de sesion */
  readonly ID_ERR_USUARIO_PASSWORD: number = -20;
  readonly ID_ERR_USUARIO_PASSWORD_TITULO: string = 'Usuario o contraseña incorrectos';
  readonly ID_ERR_USUARIO_PASSWORD_TEXTO: string = 'Verifique los datos y vuelva a intentarlo';

  readonly ID_ERR_PASSWORD_REPETIDO: number = -21;
  readonly ID_ERR_USUARIO_PASSWORD_VACIO: number = -22;
  readonly ID_ERR_USUARIO_EMAIL_VACIO: number = -23;

  /* ****************************************** */
  /* ******** CONSTANTES PARA WARNINGS ******** */
  /* ****************************************** */
  /* warnings para el registro y actualizacion de clientes */
  readonly ID_WARN_LONGITUD_MINIMA_PASSWORD = -1000;
  readonly ID_WARN_PASSWORD_VACIO = -1001;
  readonly ID_WARN_PASSWORD_NUEVO_VACIO = -1002
  readonly ID_WARN_REPETIR_PASSWORD_VACIO = -1003;
  readonly ID_WARN_PASSWORD_NO_IGUALES = -1004;
  readonly ID_WARN_PASSWORD_NUEVO_IGUAL_ACTUAL = -1005;

  /* ****************************************** */
  /* ***** CONSTANTES PARA INFORMACIONES ****** */
  /* ****************************************** */
  /* informaciones para el registro y actualizacion de datos del cliente */
  readonly ID_INFO_REGISTRACION_USUARIO_OK = 10;
  readonly ID_INFO_ACTUALIZACION_USUARIO_OK = 11;
  readonly ID_INFO_ACTUALIZACION_DATOS_OBTENIDOS_OK = 12;
  readonly ID_INFO_CAMBIAR_PASSWORD_USUARIO_OK = 13;
  readonly ID_INFO_RECUPERAR_PASSWORD_USUARIO_OK = 14;

  constructor(
    public alertController: AlertController
  ) {
  }

  public mostrarError(error: number) {
    switch (error) {
      /* errores para el inicio de sesion */
      case this.ID_ERR_USUARIO_PASSWORD:
        this.mostrarAlerta(this.ID_ERR_USUARIO_PASSWORD_TITULO, this.ID_ERR_USUARIO_PASSWORD_TEXTO, this.CSS_ERROR);
        break;
    }
  }

  public mostrarWarning(warning: number) {
    switch (warning) {
      /* errores para el registro y actualizacion de clientes */
      case this.ID_WARN_LONGITUD_MINIMA_PASSWORD:
        this.mostrarAlerta('Contraseña incorrecta.', 'La longitud mínima de la contraseña debe ser de 8 caracteres.', 'alert-warning');
        break;
      case this.ID_WARN_PASSWORD_VACIO:
        this.mostrarAlerta('Contraseña incorrecta.', 'La contraseña ingresada es incorrecta.', 'alert-warning');
        break;
      case this.ID_WARN_PASSWORD_NUEVO_VACIO:
        this.mostrarAlerta('Contraseña nueva incorrecta.', 'La contraseña nueva ingresada es incorrecta.', 'alert-warning');
        break;
      case this.ID_WARN_REPETIR_PASSWORD_VACIO:
        this.mostrarAlerta('Contraseña incorrecta.', 'La contraseña repetida ingresada es incorrecta.', 'alert-warning');
        break;
      case this.ID_WARN_PASSWORD_NO_IGUALES:
        this.mostrarAlerta('Contraseñas diferentes.', 'Las contraseñas ingresadas no son iguales.', 'alert-warning');
        break;
      case this.ID_WARN_PASSWORD_NUEVO_IGUAL_ACTUAL:
        this.mostrarAlerta('Contraseñas iguales.', 'La contraseña nueva es igual a la anterior. Por favor, ingrese una contraseña nueva diferente.', 'alert-warning');
        break;
    }
  }

  public mostrarInformacion(informacion: number) {
    switch (informacion) {
      /* errores para el inicio de sesion */
      case this.ID_INFO_REGISTRACION_USUARIO_OK:
        this.mostrarAlerta('Registración exitosa.', 'Sus datos fueron registrados con éxito. A continuación deberá ingresar a la aplicación, usando el e-mail y la contraseña recién ingresados.', 'alert-success');
        break;
      case this.ID_INFO_ACTUALIZACION_USUARIO_OK:
        this.mostrarAlerta('Datos actualizados.', 'Los datos se actualizaron con éxito.', 'alert-success');
        break;
      case this.ID_INFO_ACTUALIZACION_DATOS_OBTENIDOS_OK:
        this.mostrarAlerta('Datos actualizados.', 'Los datos se actualizaron con éxito. A continuación deberá ingresar a la aplicación, usando su e-mail y la contraseña recién ingresada.', 'alert-success');
        break;
      case this.ID_INFO_CAMBIAR_PASSWORD_USUARIO_OK:
        this.mostrarAlerta('Contraseña actualizada.', 'La contraseña se cambió con éxito.', 'alert-success');
        break;
      case this.ID_INFO_RECUPERAR_PASSWORD_USUARIO_OK:
        this.mostrarAlerta('E-mail enviado.', 'Un e-mail fue enviado a la dirección especificada. Siga las instrucciones allí indicadas.<br/>Si no encuentra el correo, no deje de revisar su carpeta de spam.', 'alert-success');
        break;
    }
  }

  private async mostrarAlerta(titulo: string, mensaje: string, cssClase: string) {
    const alert = await this.alertController.create({
      header: titulo,
      message: mensaje,
      cssClass: cssClase,
      buttons: ['ACEPTAR']
    });

    await alert.present();
  }
}